<template>
  <div class="component w-100 d-flex justify-content-center">

    <form @submit.prevent="authForm()" class="w-100 content-bg p-3" novalidate style="max-width: 400px;">
      <div class="alerts ml-3 mr-3" v-if="AdminAuthErrorGet">
        <div class="alert alert-danger">
          Ошибка в логине или пароле!
        </div>
      </div>
      <div class="form-group">
        <label for="Login">Логин</label>
        <input class="form-control bg-dark text-white" id="Login" placeholder="Введите логин" type="text"
               v-model="AdminLogin">
      </div>
      <div class="form-group">
        <label for="Pass">Пароль</label>
        <input class="form-control bg-dark text-white" id="Pass" placeholder="Введите пароль" type="password"
               v-model="AdminPass">
      </div>
      <button class="btn btn-primary" type="submit">Войти</button>
    </form>

  </div>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    name: "AdminAuth",
    data() {
      return {
        AdminLogin: '',
        AdminPass: '',
        authDone: false,
      }
    },
    computed: mapGetters(['AdminAuthErrorGet', 'AdminAuthInfoGet']),
    methods: {
      authForm: function () {
        let AdminLogin = this.AdminLogin,
          AdminPass = this.AdminPass,
          t = this;

        this.$store.dispatch('AdminAuthAct', [AdminLogin, AdminPass]);
        setTimeout(function () {
          let btn = document.getElementsByClassName('btn-primary');
          btn.disabled = true;
          if (t.AdminAuthInfoGet.AdminAuthStatus === true) {
            t.$router.push('/');
          }
        }, 1500);
      },
    },
    created() {
      if (this.AdminAuthInfoGet.AdminAuthStatus === true) {
        this.$router.push('/')
      }
    },
  }
</script>

<style scoped>

</style>
